export default "__VITE_ASSET__DzGgihtn__"